import { Box } from "@mui/material";

const FloatingButtonsContainer: React.FC<React.PropsWithChildren> = (
  props: React.PropsWithChildren
) => {
  
  return (
    <Box position="absolute" bottom={10} right={10}>
      {props.children}
    </Box>
  );
};
export default FloatingButtonsContainer;
